import React from 'react';
import MarketingHeader from '../components/MarketingHeader';
import { REQUEST_ACCESS_URL } from '../config/links';
import LegalFooter from '../components/LegalFooter';

/* Shared layout for every policy / legal / contact page.
   Renders the marketing header, a centered readable content column on
   cream paper, the marketing footer with legal links, and the
   early-access modal. Children receive plain JSX content. */
const PolicyLayout = ({ title, lastUpdated, lead, children }) => {

  return (
    <div className="fos-notebook min-h-screen flex flex-col">
      <MarketingHeader />

      <main id="main" className="flex-1 px-5 py-12 md:py-16">
        <div className="max-w-[760px] mx-auto">
          <header className="mb-8">
            <p className="nb-eyebrow" style={{ color: 'var(--nb-accent)' }}>legal &amp; trust</p>
            <h1
              className="mt-2 font-bold leading-[1.1]"
              style={{ fontFamily: 'var(--hand)', color: 'var(--ink)', fontSize: 'var(--t-lg)' }}
            >
              {title}
            </h1>
            {lead && (
              <p
                className="mt-3"
                style={{ fontFamily: 'var(--hand)', color: 'var(--ink-2)', fontSize: 'var(--t-md)', lineHeight: 1.5 }}
              >
                {lead}
              </p>
            )}
            {lastUpdated && (
              <p
                className="mt-3"
                style={{ fontFamily: 'var(--mono)', fontSize: 'var(--t-sm)', color: 'var(--ink-3)', letterSpacing: '0.4px' }}
              >
                Last updated: <time dateTime={lastUpdated}>{lastUpdated}</time>
              </p>
            )}
          </header>

          <div className="policy-body">{children}</div>
        </div>
      </main>

      <LegalFooter />

      {/* Scoped typography for policy content — keeps headings readable
          and section spacing consistent without inline styles everywhere. */}
      <style>{`
        .policy-body h2 {
          font-family: var(--hand);
          font-weight: 700;
          font-size: var(--t-md);
          color: var(--ink);
          line-height: 1.2;
          margin: 32px 0 10px;
          padding-top: 12px;
          border-top: 1px dashed var(--ink-4);
        }
        .policy-body h2:first-of-type { border-top: 0; padding-top: 0; }
        .policy-body h3 {
          font-family: var(--hand);
          font-weight: 700;
          font-size: var(--t-md);
          color: var(--ink);
          margin: 18px 0 6px;
        }
        .policy-body p,
        .policy-body li {
          font-family: var(--hand);
          font-size: var(--t-md);
          line-height: 1.55;
          color: var(--ink-2);
        }
        .policy-body p { margin: 10px 0; }
        .policy-body ul,
        .policy-body ol { padding-left: 22px; margin: 8px 0 14px; }
        .policy-body li { margin: 4px 0; }
        .policy-body a {
          color: var(--nb-accent);
          text-decoration: underline;
          text-decoration-thickness: 1.5px;
          text-underline-offset: 2px;
        }
        .policy-body a:hover { color: var(--ink); }
        .policy-body strong { color: var(--ink); font-weight: 700; }
        .policy-body .callout {
          background: rgba(246, 241, 230, 0.7);
          border: 1.5px solid var(--ink);
          border-radius: 3px;
          padding: 14px 16px;
          margin: 18px 0;
          box-shadow: 3px 4px 0 rgba(0, 0, 0, 0.08);
        }
        .policy-body code {
          font-family: var(--mono);
          font-size: var(--t-sm);
          color: var(--ink);
          background: rgba(0,0,0,0.05);
          padding: 1px 5px;
          border-radius: 2px;
        }
      `}</style>
    </div>
  );
};

export default PolicyLayout;
